var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBounceproofproductcardimg1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2828_23036)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 8,
    fill: "#6D2FEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7499 13.6102L18.9938 9.22186C17.5915 9.1238 16.3756 10.1751 16.278 11.57L8.78616 78.0943C8.68862 79.4891 9.74637 80.6994 11.1487 80.7975L77.0064 81.4445C78.4088 81.5426 79.6246 80.4913 79.7222 79.0965L84.1124 16.3134C84.2099 14.9185 83.1522 13.7083 81.7499 13.6102Z",
    fill: "black",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7503 13.6103L18.9943 9.22199C17.5919 9.12393 16.376 10.1752 16.2785 11.5701L11.8882 74.3531C11.7907 75.748 12.8485 76.9583 14.2508 77.0564L77.0068 81.4447C78.4092 81.5427 79.6251 80.4915 79.7226 79.0966L84.1128 16.3135C84.2104 14.9186 83.1526 13.7084 81.7503 13.6103Z",
    fill: "#FFFDFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1915 17.2452C80.4398 17.2626 80.6552 17.0754 80.6726 16.827C80.6899 16.5787 80.5027 16.3633 80.2544 16.3459C80.006 16.3285 79.7906 16.5158 79.7732 16.7641C79.7559 17.0125 79.9431 17.2279 80.1915 17.2452Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3897 16.8922C74.6381 16.9096 74.8535 16.7223 74.8708 16.474C74.8882 16.2256 74.7009 16.0102 74.4526 15.9929C74.2042 15.9755 73.9889 16.1627 73.9715 16.4111C73.9541 16.6594 74.1414 16.8748 74.3897 16.8922Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7369 16.5621C68.9852 16.5795 69.2006 16.3922 69.218 16.1439C69.2354 15.8956 69.0481 15.6802 68.7998 15.6628C68.5514 15.6454 68.336 15.8327 68.3187 16.081C68.3013 16.3294 68.4885 16.5448 68.7369 16.5621Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1397 16.2247C63.3881 16.2421 63.6035 16.0548 63.6208 15.8065C63.6382 15.5582 63.4509 15.3428 63.2026 15.3254C62.9543 15.308 62.7389 15.4953 62.7215 15.7436C62.7041 15.992 62.8914 16.2074 63.1397 16.2247Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4654 15.8644C57.7137 15.8817 57.9291 15.6945 57.9465 15.4461C57.9639 15.1978 57.7766 14.9824 57.5283 14.965C57.2799 14.9477 57.0645 15.1349 57.0472 15.3833C57.0298 15.6316 57.217 15.847 57.4654 15.8644Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8262 15.5807C52.0746 15.598 52.29 15.4108 52.3073 15.1625C52.3247 14.9141 52.1375 14.6987 51.8891 14.6813C51.6408 14.664 51.4254 14.8512 51.408 15.0996C51.3906 15.3479 51.5779 15.5633 51.8262 15.5807Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2369 15.298C46.4852 15.3153 46.7006 15.1281 46.718 14.8797C46.7354 14.6314 46.5481 14.416 46.2998 14.3986C46.0514 14.3813 45.836 14.5685 45.8187 14.8169C45.8013 15.0652 45.9885 15.2806 46.2369 15.298Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4439 14.9C40.6923 14.9174 40.9077 14.7301 40.925 14.4818C40.9424 14.2334 40.7551 14.018 40.5068 14.0007C40.2585 13.9833 40.0431 14.1706 40.0257 14.4189C40.0083 14.6672 40.1956 14.8827 40.4439 14.9Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8882 14.546C35.1366 14.5634 35.352 14.3761 35.3694 14.1278C35.3867 13.8794 35.1995 13.664 34.9511 13.6467C34.7028 13.6293 34.4874 13.8166 34.47 14.0649C34.4527 14.3132 34.6399 14.5286 34.8882 14.546Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6329 14.1847C23.8812 14.2021 24.0966 14.0148 24.114 13.7665C24.1314 13.5181 23.9441 13.3027 23.6958 13.2853C23.4474 13.268 23.232 13.4552 23.2147 13.7036C23.1973 13.9519 23.3845 14.1673 23.6329 14.1847Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2364 14.3868C29.4847 14.4042 29.7001 14.217 29.7175 13.9686C29.7349 13.7203 29.5476 13.5049 29.2993 13.4875C29.0509 13.4701 28.8355 13.6574 28.8182 13.9057C28.8008 14.1541 28.988 14.3695 29.2364 14.3868Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9786 14.0265C18.2269 14.0438 18.4423 13.8566 18.4597 13.6083C18.4771 13.3599 18.2898 13.1445 18.0415 13.1271C17.7931 13.1098 17.5777 13.297 17.5604 13.5454C17.543 13.7937 17.7302 14.0091 17.9786 14.0265Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9317 22.7135C80.18 22.7309 80.3954 22.5436 80.4128 22.2953C80.4302 22.0469 80.2429 21.8315 79.9946 21.8142C79.7462 21.7968 79.5308 21.984 79.5135 22.2324C79.4961 22.4807 79.6833 22.6961 79.9317 22.7135Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1353 22.361C74.3837 22.3783 74.5991 22.1911 74.6164 21.9427C74.6338 21.6944 74.4466 21.479 74.1982 21.4616C73.9499 21.4443 73.7345 21.6315 73.7171 21.8798C73.6997 22.1282 73.887 22.3436 74.1353 22.361Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.48 22.0294C68.7284 22.0468 68.9438 21.8595 68.9612 21.6112C68.9785 21.3628 68.7913 21.1474 68.5429 21.1301C68.2946 21.1127 68.0792 21.3 68.0618 21.5483C68.0445 21.7966 68.2317 22.012 68.48 22.0294Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8853 21.6964C63.1337 21.7138 63.3491 21.5265 63.3664 21.2782C63.3838 21.0298 63.1965 20.8144 62.9482 20.7971C62.6999 20.7797 62.4845 20.9669 62.4671 21.2153C62.4497 21.4636 62.637 21.679 62.8853 21.6964Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2056 21.3326C57.454 21.35 57.6694 21.1628 57.6867 20.9144C57.7041 20.6661 57.5169 20.4507 57.2685 20.4333C57.0202 20.4159 56.8048 20.6032 56.7874 20.8515C56.77 21.0999 56.9573 21.3153 57.2056 21.3326Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5718 21.0509C51.8202 21.0683 52.0356 20.881 52.053 20.6327C52.0703 20.3843 51.8831 20.1689 51.6347 20.1516C51.3864 20.1342 51.171 20.3214 51.1536 20.5698C51.1362 20.8181 51.3235 21.0335 51.5718 21.0509Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.983 20.7667C46.2313 20.7841 46.4467 20.5968 46.4641 20.3485C46.4814 20.1001 46.2942 19.8847 46.0459 19.8674C45.7975 19.85 45.5821 20.0373 45.5647 20.2856C45.5474 20.534 45.7346 20.7493 45.983 20.7667Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1871 20.3683C40.4354 20.3856 40.6508 20.1984 40.6682 19.9501C40.6855 19.7017 40.4983 19.4863 40.25 19.4689C40.0016 19.4516 39.7862 19.6388 39.7688 19.8872C39.7515 20.1355 39.9387 20.3509 40.1871 20.3683Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6343 20.0177C34.8827 20.0351 35.0981 19.8478 35.1155 19.5995C35.1328 19.3511 34.9456 19.1357 34.6972 19.1184C34.4489 19.101 34.2335 19.2882 34.2161 19.5366C34.1987 19.7849 34.386 20.0003 34.6343 20.0177Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3785 19.6564C23.6268 19.6737 23.8422 19.4865 23.8596 19.2381C23.877 18.9898 23.6897 18.7744 23.4414 18.757C23.193 18.7397 22.9776 18.9269 22.9603 19.1753C22.9429 19.4236 23.1301 19.639 23.3785 19.6564Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9825 19.8527C29.2308 19.87 29.4462 19.6828 29.4636 19.4344C29.481 19.1861 29.2937 18.9707 29.0454 18.9533C28.797 18.936 28.5816 19.1232 28.5643 19.3715C28.5469 19.6199 28.7341 19.8353 28.9825 19.8527Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7242 19.4952C17.9725 19.5126 18.1879 19.3254 18.2053 19.077C18.2227 18.8287 18.0354 18.6133 17.7871 18.5959C17.5387 18.5785 17.3233 18.7658 17.306 19.0141C17.2886 19.2625 17.4758 19.4779 17.7242 19.4952Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3858 28.5568C79.6342 28.5741 79.8495 28.3869 79.8669 28.1385C79.8843 27.8902 79.697 27.6748 79.4487 27.6574C79.2004 27.6401 78.9849 27.8273 78.9676 28.0756C78.9502 28.324 79.1375 28.5394 79.3858 28.5568Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5811 28.2037C73.8295 28.2211 74.0449 28.0339 74.0622 27.7855C74.0796 27.5372 73.8924 27.3218 73.644 27.3044C73.3957 27.287 73.1803 27.4743 73.1629 27.7226C73.1455 27.971 73.3328 28.1864 73.5811 28.2037Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9371 27.8727C68.1854 27.89 68.4008 27.7028 68.4182 27.4545C68.4356 27.2061 68.2483 26.9907 68 26.9733C67.7516 26.956 67.5362 27.1432 67.5188 27.3916C67.5015 27.6399 67.6887 27.8553 67.9371 27.8727Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.337 27.5397C62.5853 27.557 62.8007 27.3698 62.8181 27.1214C62.8354 26.8731 62.6482 26.6577 62.3999 26.6403C62.1515 26.623 61.9361 26.8102 61.9188 27.0586C61.9014 27.3069 62.0886 27.5223 62.337 27.5397Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6573 27.1754C56.9056 27.1928 57.121 27.0055 57.1384 26.7572C57.1558 26.5088 56.9685 26.2934 56.7202 26.2761C56.4718 26.2587 56.2564 26.446 56.2391 26.6943C56.2217 26.9426 56.4089 27.158 56.6573 27.1754Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0211 26.8937C51.2694 26.911 51.4848 26.7238 51.5022 26.4754C51.5195 26.2271 51.3323 26.0117 51.0839 25.9943C50.8356 25.977 50.6202 26.1642 50.6028 26.4126C50.5855 26.6609 50.7727 26.8763 51.0211 26.8937Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4371 26.61C45.6854 26.6273 45.9008 26.4401 45.9182 26.1918C45.9356 25.9434 45.7483 25.728 45.5 25.7106C45.2516 25.6933 45.0362 25.8805 45.0188 26.1289C45.0015 26.3772 45.1887 26.5926 45.4371 26.61Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6441 26.215C39.8925 26.2323 40.1079 26.0451 40.1252 25.7967C40.1426 25.5484 39.9553 25.333 39.707 25.3156C39.4587 25.2983 39.2432 25.4855 39.2259 25.7338C39.2085 25.9822 39.3958 26.1976 39.6441 26.215Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0884 25.861C34.3368 25.8783 34.5522 25.6911 34.5696 25.4427C34.5869 25.1944 34.3997 24.979 34.1513 24.9616C33.903 24.9443 33.6876 25.1315 33.6702 25.3798C33.6529 25.6282 33.8401 25.8436 34.0884 25.861Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4312 25.6984C28.6796 25.7157 28.895 25.5285 28.9123 25.2801C28.9297 25.0318 28.7424 24.8164 28.4941 24.799C28.2458 24.7817 28.0304 24.9689 28.013 25.2172C27.9956 25.4656 28.1829 25.681 28.4312 25.6984Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9561 25.3253C23.2045 25.3427 23.4199 25.1554 23.4372 24.9071C23.4546 24.6587 23.2674 24.4433 23.019 24.426C22.7707 24.4086 22.5553 24.5959 22.5379 24.8442C22.5205 25.0925 22.7078 25.3079 22.9561 25.3253Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3038 24.9772C17.5521 24.9945 17.7675 24.8073 17.7849 24.5589C17.8022 24.3106 17.615 24.0952 17.3667 24.0778C17.1183 24.0605 16.9029 24.2477 16.8855 24.4961C16.8682 24.7444 17.0554 24.9598 17.3038 24.9772Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7291 30.8595C22.9774 30.8769 23.1928 30.6896 23.2102 30.4413C23.2275 30.1929 23.0403 29.9775 22.7919 29.9602C22.5436 29.9428 22.3282 30.13 22.3108 30.3784C22.2935 30.6267 22.4807 30.8421 22.7291 30.8595Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0821 30.5133C17.3304 30.5307 17.5458 30.3434 17.5632 30.0951C17.5806 29.8467 17.3933 29.6313 17.145 29.614C16.8966 29.5966 16.6812 29.7838 16.6639 30.0322C16.6465 30.2805 16.8337 30.4959 17.0821 30.5133Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4053 36.6271C22.6537 36.6444 22.8691 36.4572 22.8864 36.2088C22.9038 35.9605 22.7166 35.7451 22.4682 35.7277C22.2199 35.7104 22.0045 35.8976 21.9871 36.146C21.9697 36.3943 22.157 36.6097 22.4053 36.6271Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7589 36.2779C17.0072 36.2953 17.2226 36.1081 17.24 35.8597C17.2573 35.6114 17.0701 35.396 16.8217 35.3786C16.5734 35.3612 16.358 35.5485 16.3406 35.7968C16.3233 36.0452 16.5105 36.2606 16.7589 36.2779Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.94 42.1764C22.1883 42.1938 22.4037 42.0065 22.4211 41.7582C22.4385 41.5098 22.2512 41.2944 22.0029 41.277C21.7545 41.2597 21.5391 41.4469 21.5218 41.6953C21.5044 41.9436 21.6917 42.159 21.94 42.1764Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.296 41.8302C16.5443 41.8476 16.7597 41.6603 16.7771 41.412C16.7944 41.1636 16.6072 40.9482 16.3588 40.9309C16.1105 40.9135 15.8951 41.1007 15.8777 41.3491C15.8604 41.5974 16.0476 41.8128 16.296 41.8302Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7266 47.9835C21.975 48.0009 22.1904 47.8136 22.2077 47.5653C22.2251 47.3169 22.0379 47.1015 21.7895 47.0842C21.5412 47.0668 21.3258 47.2541 21.3084 47.5024C21.291 47.7508 21.4783 47.9661 21.7266 47.9835Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0801 47.6344C16.3285 47.6518 16.5439 47.4645 16.5613 47.2162C16.5786 46.9678 16.3914 46.7524 16.143 46.7351C15.8947 46.7177 15.6793 46.9049 15.6619 47.1533C15.6445 47.4016 15.8318 47.617 16.0801 47.6344Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3604 53.5675C21.6088 53.5849 21.8242 53.3976 21.8415 53.1493C21.8589 52.9009 21.6716 52.6855 21.4233 52.6682C21.175 52.6508 20.9596 52.838 20.9422 53.0864C20.9248 53.3347 21.1121 53.5501 21.3604 53.5675Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7164 53.2213C15.9647 53.2387 16.1801 53.0514 16.1975 52.8031C16.2148 52.5547 16.0276 52.3393 15.7793 52.322C15.5309 52.3046 15.3155 52.4918 15.2981 52.7402C15.2808 52.9885 15.468 53.2039 15.7164 53.2213Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1368 59.0465C21.3851 59.0639 21.6005 58.8766 21.6179 58.6283C21.6353 58.3799 21.448 58.1645 21.1997 58.1472C20.9513 58.1298 20.7359 58.317 20.7186 58.5654C20.7012 58.8137 20.8884 59.0291 21.1368 59.0465Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4957 58.7008C15.744 58.7182 15.9594 58.5309 15.9768 58.2826C15.9941 58.0342 15.8069 57.8188 15.5586 57.8015C15.3102 57.7841 15.0948 57.9713 15.0774 58.2197C15.0601 58.468 15.2473 58.6834 15.4957 58.7008Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5953 64.7408C20.8436 64.7582 21.059 64.571 21.0764 64.3226C21.0938 64.0743 20.9065 63.8589 20.6582 63.8415C20.4098 63.8241 20.1944 64.0114 20.1771 64.2597C20.1597 64.5081 20.3469 64.7235 20.5953 64.7408Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9429 64.3898C15.1913 64.4071 15.4067 64.2199 15.424 63.9715C15.4414 63.7232 15.2542 63.5078 15.0058 63.4904C14.7575 63.4731 14.5421 63.6603 14.5247 63.9086C14.5073 64.157 14.6946 64.3724 14.9429 64.3898Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0469 70.5826C20.2953 70.6 20.5107 70.4128 20.528 70.1644C20.5454 69.9161 20.3582 69.7007 20.1098 69.6833C19.8615 69.6659 19.6461 69.8532 19.6287 70.1015C19.6113 70.3499 19.7986 70.5653 20.0469 70.5826Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4029 70.2379C14.6512 70.2553 14.8666 70.068 14.884 69.8197C14.9014 69.5713 14.7141 69.3559 14.4658 69.3386C14.2174 69.3212 14.002 69.5084 13.9847 69.7568C13.9673 70.0051 14.1546 70.2205 14.4029 70.2379Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8843 75.9991C20.1327 76.0165 20.3481 75.8293 20.3654 75.5809C20.3828 75.3326 20.1956 75.1172 19.9472 75.0998C19.6989 75.0824 19.4835 75.2697 19.4661 75.518C19.4487 75.7664 19.636 75.9818 19.8843 75.9991Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.232 75.651C14.4803 75.6684 14.6957 75.4811 14.7131 75.2328C14.7305 74.9844 14.5432 74.769 14.2949 74.7517C14.0465 74.7343 13.8311 74.9215 13.8138 75.1699C13.7964 75.4182 13.9836 75.6336 14.232 75.651Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2667 34.0724C79.515 34.0897 79.7304 33.9025 79.7478 33.6542C79.7651 33.4058 79.5779 33.1904 79.3296 33.173C79.0812 33.1557 78.8658 33.3429 78.8484 33.5913C78.8311 33.8396 79.0183 34.055 79.2667 34.0724Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4649 33.7194C73.7133 33.7367 73.9287 33.5495 73.946 33.3011C73.9634 33.0528 73.7761 32.8374 73.5278 32.82C73.2795 32.8027 73.064 32.9899 73.0467 33.2382C73.0293 33.4866 73.2166 33.702 73.4649 33.7194Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8155 33.3883C68.0638 33.4057 68.2792 33.2184 68.2966 32.9701C68.314 32.7217 68.1267 32.5063 67.8784 32.489C67.63 32.4716 67.4146 32.6588 67.3973 32.9072C67.3799 33.1555 67.5672 33.3709 67.8155 33.3883Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2154 33.0548C62.4637 33.0722 62.6791 32.8849 62.6965 32.6366C62.7139 32.3882 62.5266 32.1728 62.2783 32.1555C62.0299 32.1381 61.8145 32.3253 61.7972 32.5737C61.7798 32.822 61.967 33.0374 62.2154 33.0548Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5406 32.6915C56.7889 32.7089 57.0043 32.5216 57.0217 32.2733C57.0391 32.0249 56.8518 31.8096 56.6035 31.7922C56.3551 31.7748 56.1397 31.9621 56.1224 32.2104C56.105 32.4588 56.2922 32.6742 56.5406 32.6915Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.899 32.4093C51.1473 32.4267 51.3627 32.2394 51.3801 31.9911C51.3975 31.7427 51.2102 31.5273 50.9619 31.51C50.7135 31.4926 50.4981 31.6798 50.4808 31.9282C50.4634 32.1765 50.6506 32.3919 50.899 32.4093Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3096 32.1251C45.558 32.1425 45.7734 31.9552 45.7907 31.7069C45.8081 31.4585 45.6209 31.2431 45.3725 31.2258C45.1242 31.2084 44.9088 31.3957 44.8914 31.644C44.874 31.8923 45.0613 32.1077 45.3096 32.1251Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.522 31.7301C39.7704 31.7475 39.9858 31.5602 40.0031 31.3119C40.0205 31.0635 39.8333 30.8481 39.5849 30.8308C39.3366 30.8134 39.1212 31.0006 39.1038 31.249C39.0864 31.4973 39.2737 31.7127 39.522 31.7301Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9669 31.3751C34.2152 31.3925 34.4306 31.2052 34.448 30.9569C34.4653 30.7085 34.2781 30.4931 34.0297 30.4758C33.7814 30.4584 33.566 30.6457 33.5486 30.894C33.5313 31.1423 33.7185 31.3578 33.9669 31.3751Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3096 31.215C28.558 31.2323 28.7734 31.0451 28.7907 30.7967C28.8081 30.5484 28.6209 30.333 28.3725 30.3156C28.1242 30.2983 27.9088 30.4855 27.8914 30.7338C27.874 30.9822 28.0613 31.1976 28.3096 31.215Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0137 40.0211C79.2621 40.0385 79.4775 39.8512 79.4949 39.6029C79.5122 39.3545 79.325 39.1391 79.0766 39.1218C78.8283 39.1044 78.6129 39.2917 78.5955 39.54C78.5781 39.7883 78.7654 40.0037 79.0137 40.0211Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.211 39.6666C73.4593 39.684 73.6747 39.4967 73.6921 39.2484C73.7095 39.0001 73.5222 38.7846 73.2739 38.7673C73.0255 38.7499 72.8101 38.9372 72.7928 39.1855C72.7754 39.4339 72.9626 39.6493 73.211 39.6666Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5591 39.3351C67.8075 39.3524 68.0229 39.1652 68.0402 38.9168C68.0576 38.6685 67.8704 38.4531 67.622 38.4357C67.3737 38.4184 67.1583 38.6056 67.1409 38.854C67.1236 39.1023 67.3108 39.3177 67.5591 39.3351Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9674 39.0021C62.2157 39.0194 62.4311 38.8322 62.4485 38.5838C62.4658 38.3355 62.2786 38.1201 62.0302 38.1027C61.7819 38.0854 61.5665 38.2726 61.5491 38.521C61.5318 38.7693 61.719 38.9847 61.9674 39.0021Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2818 38.6368C56.5301 38.6542 56.7455 38.467 56.7629 38.2186C56.7803 37.9703 56.593 37.7549 56.3447 37.7375C56.0963 37.7201 55.8809 37.9074 55.8636 38.1557C55.8462 38.4041 56.0335 38.6195 56.2818 38.6368Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6451 38.3546C50.8934 38.372 51.1088 38.1847 51.1262 37.9364C51.1436 37.688 50.9563 37.4726 50.708 37.4553C50.4596 37.4379 50.2442 37.6252 50.2269 37.8735C50.2095 38.1218 50.3967 38.3372 50.6451 38.3546Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0587 38.0709C45.307 38.0883 45.5224 37.901 45.5398 37.6527C45.5571 37.4043 45.3699 37.1889 45.1215 37.1716C44.8732 37.1542 44.6578 37.3415 44.6404 37.5898C44.6231 37.8381 44.8103 38.0536 45.0587 38.0709Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2686 37.6715C39.517 37.6889 39.7324 37.5016 39.7497 37.2533C39.7671 37.0049 39.5798 36.7895 39.3315 36.7722C39.0832 36.7548 38.8678 36.942 38.8504 37.1904C38.833 37.4387 39.0203 37.6541 39.2686 37.6715Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7105 37.3219C33.9589 37.3393 34.1743 37.152 34.1916 36.9037C34.209 36.6553 34.0217 36.4399 33.7734 36.4226C33.5251 36.4052 33.3097 36.5924 33.2923 36.8408C33.2749 37.0891 33.4622 37.3045 33.7105 37.3219Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0533 37.1608C28.3016 37.1781 28.517 36.9909 28.5344 36.7425C28.5518 36.4942 28.3645 36.2788 28.1162 36.2614C27.8678 36.2441 27.6524 36.4313 27.6351 36.6796C27.6177 36.928 27.8049 37.1434 28.0533 37.1608Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5992 45.4337C78.8475 45.4511 79.0629 45.2638 79.0803 45.0155C79.0977 44.7671 78.9104 44.5517 78.6621 44.5344C78.4137 44.517 78.1983 44.7043 78.181 44.9526C78.1636 45.2009 78.3508 45.4163 78.5992 45.4337Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7974 45.0797C73.0458 45.0971 73.2612 44.9098 73.2785 44.6615C73.2959 44.4131 73.1087 44.1977 72.8603 44.1804C72.612 44.163 72.3966 44.3502 72.3792 44.5986C72.3618 44.8469 72.5491 45.0623 72.7974 45.0797Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.15 44.7496C67.3983 44.767 67.6137 44.5797 67.6311 44.3314C67.6484 44.0831 67.4612 43.8677 67.2129 43.8503C66.9645 43.8329 66.7491 44.0202 66.7317 44.2685C66.7144 44.5169 66.9016 44.7323 67.15 44.7496Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5474 44.4161C61.7958 44.4335 62.0112 44.2463 62.0285 43.9979C62.0459 43.7496 61.8587 43.5342 61.6103 43.5168C61.362 43.4994 61.1466 43.6867 61.1292 43.935C61.1118 44.1834 61.2991 44.3988 61.5474 44.4161Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8731 44.0499C56.1214 44.0673 56.3369 43.88 56.3542 43.6317C56.3716 43.3834 56.1843 43.168 55.936 43.1506C55.6876 43.1332 55.4723 43.3205 55.4549 43.5688C55.4375 43.8172 55.6248 44.0326 55.8731 44.0499Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2315 43.7677C50.4798 43.7851 50.6953 43.5978 50.7126 43.3495C50.73 43.1011 50.5427 42.8857 50.2944 42.8684C50.046 42.851 49.8306 43.0382 49.8133 43.2866C49.7959 43.5349 49.9832 43.7503 50.2315 43.7677Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6446 43.4869C44.8929 43.5043 45.1083 43.3171 45.1257 43.0687C45.1431 42.8204 44.9558 42.605 44.7075 42.5876C44.4591 42.5702 44.2437 42.7575 44.2264 43.0058C44.209 43.2542 44.3962 43.4696 44.6446 43.4869Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8516 43.087C39.1 43.1044 39.3154 42.9172 39.3327 42.6688C39.3501 42.4205 39.1629 42.2051 38.9145 42.1877C38.6662 42.1703 38.4508 42.3576 38.4334 42.6059C38.416 42.8543 38.6033 43.0697 38.8516 43.087Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3013 42.7364C33.5497 42.7538 33.7651 42.5666 33.7824 42.3182C33.7998 42.0699 33.6126 41.8545 33.3642 41.8371C33.1159 41.8197 32.9005 42.007 32.8831 42.2553C32.8657 42.5037 33.053 42.7191 33.3013 42.7364Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6446 42.5753C27.8929 42.5927 28.1083 42.4054 28.1257 42.1571C28.1431 41.9087 27.9558 41.6933 27.7075 41.676C27.4591 41.6586 27.2437 41.8459 27.2264 42.0942C27.209 42.3425 27.3962 42.5579 27.6446 42.5753Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4908 50.9542C78.7391 50.9716 78.9545 50.7843 78.9719 50.536C78.9893 50.2876 78.802 50.0722 78.5537 50.0549C78.3053 50.0375 78.0899 50.2248 78.0726 50.4731C78.0552 50.7215 78.2424 50.9369 78.4908 50.9542Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.692 50.6002C72.9403 50.6176 73.1557 50.4303 73.1731 50.182C73.1904 49.9336 73.0032 49.7182 72.7548 49.7009C72.5065 49.6835 72.2911 49.8708 72.2737 50.1191C72.2564 50.3674 72.4436 50.5828 72.692 50.6002Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0367 50.2696C67.285 50.287 67.5004 50.0998 67.5178 49.8514C67.5352 49.6031 67.3479 49.3877 67.0996 49.3703C66.8512 49.3529 66.6358 49.5402 66.6185 49.7885C66.6011 50.0369 66.7883 50.2523 67.0367 50.2696Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4424 49.9342C61.6908 49.9516 61.9062 49.7643 61.9236 49.516C61.9409 49.2676 61.7537 49.0522 61.5053 49.0349C61.257 49.0175 61.0416 49.2047 61.0242 49.4531C61.0069 49.7014 61.1941 49.9168 61.4424 49.9342Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7652 49.5704C56.0135 49.5878 56.2289 49.4005 56.2463 49.1522C56.2637 48.9039 56.0764 48.6885 55.8281 48.6711C55.5797 48.6537 55.3643 48.841 55.347 49.0893C55.3296 49.3377 55.5169 49.5531 55.7652 49.5704Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.126 49.2872C50.3744 49.3046 50.5898 49.1173 50.6071 48.869C50.6245 48.6207 50.4373 48.4053 50.1889 48.3879C49.9406 48.3705 49.7252 48.5578 49.7078 48.8061C49.6904 49.0545 49.8777 49.2699 50.126 49.2872Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5367 49.0045C44.785 49.0219 45.0004 48.8346 45.0178 48.5863C45.0352 48.3379 44.8479 48.1225 44.5996 48.1052C44.3512 48.0878 44.1358 48.2751 44.1185 48.5234C44.1011 48.7717 44.2883 48.9871 44.5367 49.0045Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7491 48.608C38.9974 48.6254 39.2128 48.4381 39.2302 48.1898C39.2476 47.9415 39.0603 47.7261 38.812 47.7087C38.5636 47.6913 38.3482 47.8786 38.3309 48.1269C38.3135 48.3753 38.5007 48.5907 38.7491 48.608Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.188 48.255C33.4364 48.2724 33.6518 48.0851 33.6692 47.8368C33.6865 47.5884 33.4993 47.373 33.2509 47.3557C33.0026 47.3383 32.7872 47.5255 32.7698 47.7739C32.7525 48.0222 32.9397 48.2376 33.188 48.255Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5367 48.0929C27.785 48.1103 28.0004 47.923 28.0178 47.6747C28.0352 47.4263 27.8479 47.2109 27.5996 47.1936C27.3512 47.1762 27.1358 47.3634 27.1185 47.6118C27.1011 47.8601 27.2883 48.0755 27.5367 48.0929Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9288 56.795C78.1771 56.8124 78.3925 56.6252 78.4099 56.3768C78.4273 56.1285 78.24 55.9131 77.9917 55.8957C77.7433 55.8783 77.5279 56.0656 77.5105 56.3139C77.4932 56.5623 77.6804 56.7777 77.9288 56.795Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.127 56.4381C72.3754 56.4555 72.5908 56.2682 72.6081 56.0199C72.6255 55.7715 72.4383 55.5561 72.1899 55.5388C71.9416 55.5214 71.7262 55.7086 71.7088 55.957C71.6914 56.2053 71.8787 56.4207 72.127 56.4381Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4717 56.109C66.7201 56.1264 66.9355 55.9391 66.9529 55.6908C66.9702 55.4424 66.783 55.227 66.5346 55.2097C66.2863 55.1923 66.0709 55.3795 66.0535 55.6279C66.0362 55.8762 66.2234 56.0916 66.4717 56.109Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8829 55.774C61.1312 55.7914 61.3466 55.6042 61.364 55.3558C61.3814 55.1075 61.1941 54.8921 60.9458 54.8747C60.6974 54.8573 60.482 55.0446 60.4646 55.2929C60.4473 55.5413 60.6345 55.7567 60.8829 55.774Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2032 55.4083C55.4515 55.4257 55.6669 55.2384 55.6843 54.9901C55.7017 54.7418 55.5144 54.5263 55.2661 54.509C55.0177 54.4916 54.8023 54.6789 54.785 54.9272C54.7676 55.1756 54.9548 55.391 55.2032 55.4083Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5665 55.1266C49.8148 55.1439 50.0302 54.9567 50.0476 54.7084C50.0649 54.46 49.8777 54.2446 49.6294 54.2272C49.381 54.2099 49.1656 54.3971 49.1482 54.6455C49.1309 54.8938 49.3181 55.1092 49.5665 55.1266Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9771 54.8453C44.2255 54.8627 44.4409 54.6755 44.4582 54.4271C44.4756 54.1788 44.2883 53.9634 44.04 53.946C43.7917 53.9286 43.5763 54.1159 43.5589 54.3642C43.5415 54.6126 43.7288 54.828 43.9771 54.8453Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1866 54.4474C38.4349 54.4647 38.6503 54.2775 38.6677 54.0292C38.6851 53.7808 38.4978 53.5654 38.2495 53.548C38.0011 53.5307 37.7857 53.7179 37.7684 53.9663C37.751 54.2146 37.9382 54.43 38.1866 54.4474Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6285 54.0934C32.8768 54.1107 33.0922 53.9235 33.1096 53.6751C33.127 53.4268 32.9397 53.2114 32.6914 53.194C32.443 53.1767 32.2276 53.3639 32.2103 53.6123C32.1929 53.8606 32.3801 54.076 32.6285 54.0934Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9742 53.9337C27.2225 53.9511 27.4379 53.7638 27.4553 53.5155C27.4727 53.2671 27.2854 53.0517 27.0371 53.0344C26.7887 53.017 26.5733 53.2042 26.556 53.4526C26.5386 53.7009 26.7258 53.9163 26.9742 53.9337Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7652 62.2936C78.0135 62.3109 78.229 62.1237 78.2463 61.8753C78.2637 61.627 78.0764 61.4116 77.8281 61.3942C77.5797 61.3769 77.3643 61.5641 77.347 61.8125C77.3296 62.0608 77.5169 62.2762 77.7652 62.2936Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9664 61.9381C72.2147 61.9555 72.4301 61.7682 72.4475 61.5199C72.4648 61.2715 72.2776 61.0561 72.0292 61.0388C71.7809 61.0214 71.5655 61.2086 71.5481 61.457C71.5308 61.7053 71.718 61.9207 71.9664 61.9381Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3116 61.609C66.5599 61.6264 66.7753 61.4391 66.7927 61.1908C66.8101 60.9424 66.6228 60.727 66.3745 60.7097C66.1261 60.6923 65.9107 60.8795 65.8934 61.1279C65.876 61.3762 66.0632 61.5916 66.3116 61.609Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7168 61.275C60.9652 61.2924 61.1806 61.1051 61.198 60.8568C61.2153 60.6084 61.0281 60.393 60.7797 60.3757C60.5314 60.3583 60.316 60.5456 60.2986 60.7939C60.2813 61.0422 60.4685 61.2577 60.7168 61.275Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0396 60.9098C55.288 60.9272 55.5034 60.7399 55.5207 60.4916C55.5381 60.2432 55.3508 60.0278 55.1025 60.0104C54.8542 59.9931 54.6388 60.1803 54.6214 60.4287C54.604 60.677 54.7913 60.8924 55.0396 60.9098Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4 60.6276C49.6483 60.6449 49.8637 60.4577 49.8811 60.2093C49.8984 59.961 49.7112 59.7456 49.4629 59.7282C49.2145 59.7109 48.9991 59.8981 48.9817 60.1464C48.9644 60.3948 49.1516 60.6102 49.4 60.6276Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8165 60.3468C44.0648 60.3642 44.2802 60.1769 44.2976 59.9286C44.3149 59.6802 44.1277 59.4648 43.8794 59.4475C43.631 59.4301 43.4156 59.6173 43.3982 59.8657C43.3809 60.114 43.5681 60.3294 43.8165 60.3468Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0181 59.9484C38.2665 59.9657 38.4819 59.7785 38.4992 59.5301C38.5166 59.2818 38.3294 59.0664 38.081 59.049C37.8327 59.0317 37.6173 59.2189 37.5999 59.4672C37.5825 59.7156 37.7698 59.931 38.0181 59.9484Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4678 59.5963C32.7162 59.6137 32.9316 59.4264 32.9489 59.1781C32.9663 58.9297 32.7791 58.7143 32.5307 58.697C32.2824 58.6796 32.067 58.8668 32.0496 59.1152C32.0322 59.3635 32.2195 59.5789 32.4678 59.5963Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8135 59.4352C27.0619 59.4525 27.2773 59.2653 27.2946 59.0169C27.312 58.7686 27.1248 58.5532 26.8764 58.5358C26.6281 58.5185 26.4127 58.7057 26.3953 58.9541C26.3779 59.2024 26.5652 59.4178 26.8135 59.4352Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2608 68.1539C77.5091 68.1713 77.7245 67.984 77.7419 67.7357C77.7593 67.4874 77.572 67.272 77.3237 67.2546C77.0753 67.2372 76.8599 67.4245 76.8426 67.6728C76.8252 67.9212 77.0124 68.1366 77.2608 68.1539Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.462 67.7999C71.7103 67.8173 71.9257 67.63 71.9431 67.3817C71.9604 67.1333 71.7732 66.9179 71.5249 66.9006C71.2765 66.8832 71.0611 67.0705 71.0438 67.3188C71.0264 67.5671 71.2136 67.7826 71.462 67.7999Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8067 67.4693C66.0551 67.4867 66.2704 67.2995 66.2878 67.0511C66.3052 66.8028 66.1179 66.5874 65.8696 66.57C65.6212 66.5527 65.4058 66.7399 65.3885 66.9882C65.3711 67.2366 65.5584 67.452 65.8067 67.4693Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2125 67.1339C60.4608 67.1513 60.6762 66.964 60.6936 66.7157C60.7109 66.4673 60.5237 66.2519 60.2754 66.2346C60.027 66.2172 59.8116 66.4044 59.7942 66.6528C59.7769 66.9011 59.9641 67.1165 60.2125 67.1339Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5323 66.7696C54.7806 66.787 54.996 66.5998 55.0134 66.3514C55.0308 66.1031 54.8435 65.8877 54.5952 65.8703C54.3468 65.8529 54.1314 66.0402 54.1141 66.2885C54.0967 66.5369 54.2839 66.7523 54.5323 66.7696Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8961 66.4879C49.1444 66.5053 49.3598 66.318 49.3772 66.0697C49.3945 65.8213 49.2073 65.6059 48.9589 65.5886C48.7106 65.5712 48.4952 65.7585 48.4778 66.0068C48.4605 66.2551 48.6477 66.4705 48.8961 66.4879Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3121 66.2057C43.5604 66.223 43.7758 66.0358 43.7932 65.7875C43.8106 65.5391 43.6233 65.3237 43.375 65.3063C43.1266 65.289 42.9112 65.4762 42.8938 65.7246C42.8765 65.9729 43.0637 66.1883 43.3121 66.2057Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5132 65.8072C37.7616 65.8246 37.977 65.6374 37.9944 65.389C38.0117 65.1407 37.8245 64.9253 37.5761 64.9079C37.3278 64.8905 37.1124 65.0778 37.095 65.3261C37.0777 65.5745 37.2649 65.7899 37.5132 65.8072Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9634 65.4581C32.2118 65.4755 32.4272 65.2882 32.4446 65.0399C32.4619 64.7916 32.2747 64.5762 32.0263 64.5588C31.778 64.5414 31.5626 64.7287 31.5452 64.977C31.5279 65.2254 31.7151 65.4408 31.9634 65.4581Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3067 65.2926C26.555 65.31 26.7704 65.1227 26.7878 64.8744C26.8052 64.626 26.6179 64.4106 26.3696 64.3933C26.1212 64.3759 25.9058 64.5631 25.8885 64.8115C25.8711 65.0598 26.0584 65.2752 26.3067 65.2926Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1006 73.6554C77.349 73.6728 77.5644 73.4855 77.5818 73.2372C77.5991 72.9888 77.4119 72.7734 77.1635 72.7561C76.9152 72.7387 76.6998 72.9259 76.6824 73.1743C76.6651 73.4226 76.8523 73.638 77.1006 73.6554Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2984 73.298C71.5467 73.3153 71.7621 73.1281 71.7795 72.8797C71.7969 72.6314 71.6096 72.416 71.3613 72.3986C71.1129 72.3813 70.8975 72.5685 70.8802 72.8169C70.8628 73.0652 71.0501 73.2806 71.2984 73.298Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6461 72.9679C65.8944 72.9853 66.1098 72.798 66.1272 72.5497C66.1445 72.3013 65.9573 72.0859 65.7089 72.0686C65.4606 72.0512 65.2452 72.2384 65.2278 72.4868C65.2105 72.7351 65.3977 72.9505 65.6461 72.9679Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0489 72.6334C60.2972 72.6508 60.5126 72.4635 60.53 72.2152C60.5474 71.9669 60.3601 71.7514 60.1118 71.7341C59.8634 71.7167 59.648 71.904 59.6307 72.1523C59.6133 72.4007 59.8005 72.6161 60.0489 72.6334Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3692 72.2711C54.6176 72.2885 54.8329 72.1012 54.8503 71.8529C54.8677 71.6045 54.6804 71.3891 54.4321 71.3718C54.1837 71.3544 53.9683 71.5417 53.951 71.79C53.9336 72.0383 54.1209 72.2537 54.3692 72.2711Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7354 71.9869C48.9838 72.0043 49.1992 71.8171 49.2165 71.5687C49.2339 71.3204 49.0466 71.105 48.7983 71.0876C48.55 71.0702 48.3346 71.2575 48.3172 71.5058C48.2998 71.7542 48.4871 71.9696 48.7354 71.9869Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1431 71.7081C43.3915 71.7255 43.6069 71.5382 43.6242 71.2899C43.6416 71.0416 43.4544 70.8262 43.206 70.8088C42.9577 70.7914 42.7423 70.9787 42.7249 71.227C42.7075 71.4754 42.8948 71.6908 43.1431 71.7081Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3531 71.3072C37.6014 71.3246 37.8168 71.1374 37.8342 70.889C37.8516 70.6407 37.6643 70.4253 37.416 70.4079C37.1676 70.3905 36.9522 70.5778 36.9349 70.8261C36.9175 71.0745 37.1047 71.2899 37.3531 71.3072Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7974 70.9547C32.0458 70.9721 32.2612 70.7848 32.2785 70.5365C32.2959 70.2881 32.1087 70.0727 31.8603 70.0554C31.612 70.038 31.3966 70.2252 31.3792 70.4736C31.3618 70.7219 31.5491 70.9373 31.7974 70.9547Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1461 70.7941C26.3944 70.8114 26.6098 70.6242 26.6272 70.3758C26.6445 70.1275 26.4573 69.9121 26.2089 69.8947C25.9606 69.8774 25.7452 70.0646 25.7278 70.313C25.7105 70.5613 25.8977 70.7767 26.1461 70.7941Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7388 79.0875C76.9872 79.1049 77.2026 78.9176 77.22 78.6693C77.2373 78.421 77.0501 78.2055 76.8017 78.1882C76.5534 78.1708 76.338 78.3581 76.3206 78.6064C76.3032 78.8548 76.4905 79.0702 76.7388 79.0875Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9341 78.7316C71.1825 78.7489 71.3979 78.5617 71.4153 78.3133C71.4326 78.065 71.2454 77.8496 70.997 77.8322C70.7487 77.8149 70.5333 78.0021 70.5159 78.2504C70.4986 78.4988 70.6858 78.7142 70.9341 78.7316Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2842 78.4029C65.5326 78.4203 65.748 78.2331 65.7653 77.9847C65.7827 77.7364 65.5955 77.521 65.3471 77.5036C65.0988 77.4862 64.8834 77.6735 64.866 77.9218C64.8487 78.1702 65.0359 78.3856 65.2842 78.4029Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.69 78.067C59.9384 78.0844 60.1538 77.8971 60.1711 77.6488C60.1885 77.4004 60.0012 77.185 59.7529 77.1677C59.5045 77.1503 59.2891 77.3376 59.2718 77.5859C59.2544 77.8342 59.4417 78.0496 59.69 78.067Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0103 77.7062C54.2587 77.7235 54.4741 77.5363 54.4914 77.288C54.5088 77.0396 54.3216 76.8242 54.0732 76.8068C53.8249 76.7895 53.6095 76.9767 53.5921 77.2251C53.5747 77.4734 53.762 77.6888 54.0103 77.7062Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.379 77.422C48.6273 77.4394 48.8427 77.2521 48.8601 77.0038C48.8774 76.7554 48.6902 76.54 48.4419 76.5227C48.1935 76.5053 47.9781 76.6925 47.9607 76.9409C47.9434 77.1892 48.1306 77.4046 48.379 77.422Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7896 77.1403C43.038 77.1576 43.2534 76.9704 43.2707 76.722C43.2881 76.4737 43.1008 76.2583 42.8525 76.2409C42.6042 76.2236 42.3888 76.4108 42.3714 76.6591C42.354 76.9075 42.5413 77.1229 42.7896 77.1403Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9971 76.7423C37.2455 76.7597 37.4609 76.5724 37.4782 76.3241C37.4956 76.0757 37.3084 75.8603 37.06 75.843C36.8117 75.8256 36.5963 76.0128 36.5789 76.2612C36.5615 76.5095 36.7488 76.7249 36.9971 76.7423Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4415 76.3883C31.6898 76.4057 31.9052 76.2184 31.9226 75.9701C31.9399 75.7217 31.7527 75.5063 31.5044 75.489C31.256 75.4716 31.0406 75.6588 31.0232 75.9072C31.0059 76.1555 31.1931 76.3709 31.4415 76.3883Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7872 76.2291C26.0355 76.2465 26.2509 76.0592 26.2683 75.8109C26.2856 75.5625 26.0984 75.3471 25.8501 75.3298C25.6017 75.3124 25.3863 75.4997 25.3689 75.748C25.3516 75.9963 25.5388 76.2118 25.7872 76.2291Z",
    fill: "#FFD106",
    fillOpacity: 0.69
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2828_23036)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.9445 28.7539L23.5029 41.2284L21.8173 65.3332L72.3114 68.8641L73.997 44.7592L54.5002 29.4221C49.6362 26.0666 50.5127 26.0071 44.9445 28.7539Z",
    fill: "#DF9B2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0959 32.1071L28.0612 29.0978C27.4274 29.0535 26.8776 29.5314 26.8333 30.1652L24.7068 60.5764C24.6624 61.2102 25.1403 61.7599 25.7741 61.8042L68.8088 64.8135C69.4426 64.8578 69.9924 64.3799 70.0367 63.7461L72.1632 33.3349C72.2076 32.7011 71.7297 32.1514 71.0959 32.1071Z",
    fill: "#FFFAF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6058 35.5967L38.1857 34.2387C38.1262 34.2346 38.0804 34.1904 38.0839 34.1406L38.107 33.8112C38.1104 33.7614 38.1619 33.7241 38.2214 33.7283L57.6415 35.0862C57.701 35.0904 57.7469 35.1345 57.7434 35.1843L57.7203 35.5137C57.7168 35.5635 57.6653 35.6009 57.6058 35.5967Z",
    fill: "#FAF2F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3495 39.3385L37.9294 37.9805C37.8699 37.9763 37.8241 37.9321 37.8276 37.8824L37.8506 37.553C37.8541 37.5032 37.9056 37.4658 37.9651 37.47L57.3852 38.8279C57.4446 38.8321 57.4905 38.8763 57.487 38.9261L57.464 39.2555C57.4604 39.3053 57.4089 39.3426 57.3495 39.3385Z",
    fill: "#FAF2F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7333 54.9709L31.1509 53.2519C31.084 53.2473 31.0325 53.1976 31.0364 53.1416L31.0578 52.8347C31.0617 52.7787 31.1197 52.7367 31.1866 52.7414L55.769 54.4604C55.8359 54.4651 55.8874 54.5147 55.8835 54.5707L55.8621 54.8776C55.8581 54.9335 55.8002 54.9756 55.7333 54.9709Z",
    fill: "#FAF2F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4462 59.0549L30.8638 57.3359C30.7969 57.3312 30.7453 57.2816 30.7493 57.2256L30.7707 56.9187C30.7746 56.8627 30.8326 56.8207 30.8995 56.8254L55.4819 58.5444C55.5488 58.549 55.6003 58.5987 55.5964 58.6547L55.575 58.9616C55.571 59.0176 55.5131 59.0596 55.4462 59.0549Z",
    fill: "#FAF2F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0527 57.6764L31.003 55.2954C30.936 55.2907 30.8845 55.2411 30.8884 55.185L30.9099 54.8782C30.9138 54.8222 30.9717 54.7802 31.0387 54.7849L65.0884 57.1659C65.1553 57.1705 65.2069 57.2202 65.2029 57.2762L65.1815 57.5831C65.1776 57.6391 65.1196 57.6811 65.0527 57.6764Z",
    fill: "#FAF2F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6366 49.5465L37.2165 48.1885C37.157 48.1843 37.1112 48.1402 37.1147 48.0904L37.1377 47.7609C37.1412 47.7111 37.1927 47.6738 37.2522 47.678L56.6723 49.036C56.7318 49.0401 56.7776 49.0842 56.7741 49.134L56.7511 49.4635C56.7476 49.5133 56.6961 49.5506 56.6366 49.5465Z",
    fill: "#FAF2F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.032 42.2296L32.8903 40.1918C32.8394 40.1882 32.8002 40.1505 32.8032 40.1079L32.8281 39.7522C32.8311 39.7096 32.8752 39.6777 32.926 39.6813L62.0677 41.7191C62.1186 41.7226 62.1577 41.7603 62.1548 41.8029L62.1299 42.1586C62.1269 42.2012 62.0829 42.2331 62.032 42.2296Z",
    fill: "#FAF2F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8254 45.1231L32.6838 43.0853C32.6329 43.0817 32.5937 43.044 32.5967 43.0014L32.6215 42.6458C32.6245 42.6032 32.6686 42.5713 32.7195 42.5748L61.8611 44.6126C61.912 44.6162 61.9512 44.6539 61.9482 44.6965L61.9234 45.0521C61.9204 45.0947 61.8763 45.1266 61.8254 45.1231Z",
    fill: "#FAF2F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6648 47.504L32.5231 45.4662C32.4722 45.4626 32.433 45.4249 32.436 45.3823L32.4609 45.0266C32.4639 44.984 32.508 44.9521 32.5588 44.9557L61.7005 46.9935C61.7514 46.997 61.7906 47.0348 61.7876 47.0774L61.7627 47.433C61.7597 47.4756 61.7157 47.5075 61.6648 47.504Z",
    fill: "#FAF2F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6634 66.9946L23.4595 41.3091L47.4678 60.7887L73.9536 44.84L72.1574 70.5255L21.6634 66.9946Z",
    fill: "#FFBE55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1575 70.5253L21.6635 66.9945L46.6001 56.0133C47.6571 55.5479 48.8768 55.642 49.8499 56.2641L72.1575 70.5253Z",
    fill: "#FFCD7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1278 39.8871C46.4931 39.7029 44.1961 41.6997 44.0118 44.3344C43.8276 46.9691 45.8244 49.2661 48.4591 49.4504C51.0938 49.6346 53.3909 47.6378 53.5751 45.0031C53.7593 42.3684 51.7625 40.0713 49.1278 39.8871ZM51.156 43.7288L48.2552 46.2504C48.1836 46.3127 48.0901 46.3446 47.9944 46.3379C47.8988 46.3312 47.8106 46.2866 47.7484 46.2149L46.4898 44.7671C46.3608 44.6188 46.3769 44.3892 46.5252 44.2603C46.6736 44.1313 46.9031 44.1473 47.0321 44.2957L48.055 45.4724L50.6846 43.1865C50.8329 43.0575 51.0625 43.0736 51.1914 43.2219C51.3204 43.3703 51.3047 43.595 51.156 43.7288Z",
    fill: "#5DBEBA"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M84.8444 52.6751L51.8655 51.8206C50.9373 51.7965 50.1653 52.5295 50.1412 53.4578L48.5048 74.9124C48.4807 75.8407 49.2137 76.6127 50.142 76.6367L83.1201 76.6373C84.0484 76.6614 84.8204 75.9284 84.8444 75.0001L86.4817 54.3994C86.5057 53.4711 85.7727 52.6991 84.8444 52.6751Z",
    fill: "black",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9987 51.7907L86.9577 52.6966C87.823 52.719 88.5063 53.4387 88.4839 54.304L87.9569 74.6458C87.9344 75.5111 87.2147 76.1945 86.3494 76.1721L51.3904 75.2662C50.5252 75.2438 49.8418 74.5241 49.8642 73.6588L50.3913 53.317C50.4137 52.4517 51.1335 51.7683 51.9987 51.7907Z",
    fill: "#6D2FEC",
    stroke: "#C3A6FF",
    strokeWidth: 0.43
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.7998,
    y: 54.064,
    width: 6.79277,
    height: 4,
    rx: 1,
    transform: "rotate(3.51131 52.7998 54.064)",
    fill: "#C3A6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.7583 61.7502C68.736 61.925 68.6318 62.0849 68.4684 62.195C68.305 62.3052 68.0955 62.357 67.8852 62.339L52.548 61.9416C52.3371 61.9487 52.1305 61.8861 51.973 61.7676C51.8155 61.6491 51.7198 61.4841 51.7065 61.3084L51.7146 60.9969C51.7369 60.8221 51.8411 60.6623 52.0045 60.5521C52.1679 60.442 52.3774 60.3902 52.5877 60.4082L67.9249 60.8056C68.1358 60.7985 68.3424 60.8611 68.4999 60.9796C68.6574 61.0981 68.7531 61.263 68.7664 61.4388L68.7583 61.7502Z",
    fill: "#C3A6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.8468 64.1279C65.8275 64.3028 65.74 64.4632 65.6034 64.574C65.4667 64.6849 65.2919 64.7374 65.1167 64.7202L52.3395 64.3892C52.1637 64.3972 51.9918 64.3358 51.8611 64.218C51.7303 64.1001 51.6513 63.9355 51.6411 63.7598L51.6492 63.4486C51.6685 63.2737 51.7559 63.1134 51.8926 63.0025C52.0292 62.8916 52.2041 62.839 52.3792 62.8562L65.1565 63.1872C65.3322 63.1792 65.5041 63.2408 65.6349 63.3586C65.7656 63.4764 65.8446 63.641 65.8548 63.8167L65.8468 64.1279Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.0355 66.6108C67.0149 66.7857 66.9201 66.9458 66.7717 67.0564C66.6232 67.167 66.4331 67.2191 66.2424 67.2015L52.3376 66.8412C52.1463 66.8489 51.9591 66.787 51.8166 66.6689C51.674 66.5508 51.5877 66.386 51.5762 66.2102L51.5842 65.8987C51.6049 65.7238 51.6997 65.5639 51.8481 65.4533C51.9966 65.3428 52.1867 65.2905 52.3773 65.308L66.2822 65.6683C66.4734 65.6607 66.6606 65.7227 66.8031 65.8408C66.9456 65.9589 67.032 66.1236 67.0436 66.2993L67.0355 66.6108Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4849 72.5545L51.8467 71.987L51.5078 71.4321L51.7336 71.438L51.9576 71.8258L52.1897 71.4498L52.3857 71.4549L52.0531 71.9625L52.4322 72.5788L52.2008 72.5728L51.9441 72.1307L51.6857 72.5595L51.4849 72.5545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5063 72.5814L52.8682 72.0138L52.5293 71.459L52.7551 71.4648L52.9793 71.8527L53.2114 71.4767L53.4074 71.4817L53.0749 71.9894L53.4539 72.6057L53.2226 72.5997L52.9658 72.1575L52.7074 72.5864L52.5063 72.5814Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.52 72.6083L53.8818 72.0407L53.543 71.4858L53.7687 71.4917L53.9928 71.8795L54.2248 71.5035L54.4208 71.5086L54.0883 72.0162L54.4673 72.6326L54.236 72.6266L53.9792 72.1844L53.7208 72.6132L53.52 72.6083Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5415 72.6341L54.9033 72.0666L54.5645 71.5117L54.7902 71.5176L55.0142 71.9054L55.2464 71.5294L55.4423 71.5345L55.1098 72.0421L55.4888 72.6584L55.2575 72.6524L55.0007 72.2103L54.7423 72.6391L54.5415 72.6341Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5591 72.66L55.9209 72.0925L55.582 71.5376L55.8078 71.5434L56.0318 71.9313L56.2639 71.5553L56.4599 71.5603L56.1274 72.068L56.5064 72.6843L56.2753 72.6783L56.0186 72.2361L55.7602 72.665L55.5591 72.66Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5762 72.6874L56.938 72.1198L56.5991 71.5649L56.8249 71.5708L57.0492 71.9586L57.2813 71.5826L57.4773 71.5877L57.1447 72.0953L57.5238 72.7117L57.2924 72.7057L57.0359 72.2635L56.7775 72.6923L56.5762 72.6874Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5942 72.7132L57.9561 72.1457L57.6172 71.5908L57.8429 71.5967L58.0669 71.9845L58.2991 71.6085L58.495 71.6136L58.1625 72.1212L58.5416 72.7375L58.3102 72.7315L58.0535 72.2894L57.795 72.7182L57.5942 72.7132Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6118 72.7381L58.9736 72.1706L58.6348 71.6157L58.8605 71.6216L59.0848 72.0094L59.3169 71.6334L59.5129 71.6385L59.1803 72.1461L59.5594 72.7624L59.328 72.7564L59.0713 72.3143L58.8129 72.7431L58.6118 72.7381Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6289 72.7669L59.9907 72.1994L59.6519 71.6445L59.8776 71.6504L60.1019 72.0382L60.334 71.6622L60.53 71.6673L60.1974 72.1749L60.5765 72.7913L60.3451 72.7853L60.0884 72.3431L59.83 72.7719L59.6289 72.7669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6465 72.7923L61.0083 72.2248L60.6694 71.6699L60.8952 71.6758L61.1192 72.0636L61.3513 71.6876L61.5473 71.6927L61.2148 72.2003L61.5938 72.8166L61.3625 72.8106L61.106 72.3685L60.8475 72.7973L60.6465 72.7923Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2828_23036"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2828_23036"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.5923,
    y: 25.1074,
    width: 50.6174,
    height: 41.9894,
    rx: 4,
    transform: "rotate(4 24.5923 25.1074)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBounceproofproductcardimg1);
export default __webpack_public_path__ + "static/media/bounceproofproductcardimg1.57db073acbb2d559ba382fe8d4f66377.svg";
export { ForwardRef as ReactComponent };